import Home from "./components/Home/Home";
import Update from "./components/Database/Update";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import "./css/theme.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import CustomMenu from "./components/CustomMenu";
import CustomFooter from "./components/CustomFooter";
import CookieBanner from "./components/CookieBanner";
import DiplomaticDirectory from "./components/Ressources/DiplomaticDirectory";
import GlobalConsularForum from "./components/Ressources/GlobalConsularForum";
import News from "./components/Ressources/News";
import InterestingLinks from "./components/Ressources/InterestingLinks";
import PrivacyAndTerms from "./components/PrivacyAndTerms/PrivacyAndTerms";
import Partners from "./components/TheCenter/Partners";
import About from "./components/TheCenter/About";
import Notice from "./components/TheCenter/Notice";
import Contact from "./components/TheCenter/Contact";
import DidYouKnow from "./components/Ressources/DidYouKnow";
import HonoraryDirectory from "./components/Honorary/HonoraryDirectory";
import HonorarySpaces from "./components/Honorary/HonorarySpaces";
import HonoraryNews from "./components/Honorary/HonoraryNews";
import HonoraryJobs from "./components/Honorary/HonoraryJobs";
import HonoraryCorpsDirectory from "./components/Honorary/HonoraryCorpsDirectory";
import ViennaConventions from "./components/Ressources/ViennaConventions";
import WhatAreConsularAffairs from "./components/Ressources/WhatAreConsularAffairs";
import WhatAreDiplomaticNetworks from "./components/Ressources/WhatAreDiplomaticNetworks";
import ResearchFellows from "./components/TheCenter/ResearchFellows";
import Correspondents from "./components/TheCenter/Correspondents";
import Authors from "./components/Publications/Authors";
import Bibliography from "./components/Publications/Bibliography";
import Glossary from "./components/Ressources/Glossary";
import HonoraryBibliography from "./components/Honorary/HonoraryBibliography";
import HenryGrahamGreene from "./components/Honorary/HenryGrahamGreene";
import DailyDatabaseReview from "./components/WorldMap/DailyDatabaseReview";
import Newsletter from "./components/Publications/Newsletter";
import Index from "./components/Publications/Index";
import RankingInCountry from "./components/RankingComparison/RankingInCountry";
import RankingOfCountry from "./components/RankingComparison/RankingOfCountry";
import RankingInCity from "./components/RankingComparison/RankingInCity";
import LawRegulations from "./components/Ressources/LawRegulations";
import Passports from "./components/Ressources/Passports";
import Submissions from "./components/Publications/Submissions";
import Contributors from "./components/TheCenter/Contributors";
import Etymology from "./components/Ressources/Etymology";
import ScrollToTop from "./components/Common/ScrollToTop";
import Migrations from "./components/Ressources/Migrations";
import SupportConsularResearch from "./components/TheCenter/SupportConsularResearch";
import JobsAndInternships from "./components/Ressources/JobsAndInternships";

function App() {
  return (
    <div className="pagewrap">
      <BrowserRouter>
        <ScrollToTop />
        <nav>
          <CustomMenu />
        </nav>
        <main className="Site-content">
          <CookieBanner />
          <div style={{ color: "black" }}>
            <Routes>
              {/*First tab*/}
              <Route path="ranking-of-country" element={<RankingOfCountry />} />
              <Route path="ranking-in-country" element={<RankingInCountry />} />
              <Route path="ranking-in-city" element={<RankingInCity />} />
              <Route
                path="daily-database-review"
                element={<DailyDatabaseReview />}
              />
              <Route path="update" element={<Update />} />

              {/*Publications tab*/}
              <Route
                path="the-consular-daily-press-review"
                element={<News />}
              />
              <Route
                path="the-consular-bibliography"
                element={<Bibliography />}
              />
              <Route path="the-consular-newsletter" element={<Newsletter />} />
              <Route path="authors" element={<Authors />} />
              <Route path="index" element={<Index />} />
              <Route path="submission-guidelines" element={<Submissions />} />

              {/*Honorary consuls tab*/}
              <Route
                path="who-are-honorary-consuls"
                element={<HonoraryDirectory />}
              />
              <Route
                path="honorary-bibliography"
                element={<HonoraryBibliography />}
              />
              <Route
                path="honorary-corps-directory"
                element={<HonoraryCorpsDirectory />}
              />
              <Route path="honorary-jobs" element={<HonoraryJobs />} />
              <Route path="honorary-news" element={<HonoraryNews />} />
              <Route path="honorary-solutions" element={<HonorarySpaces />} />
              <Route
                path="henry-graham-greene"
                element={<HenryGrahamGreene />}
              />

              {/*Resources tab*/}
              <Route
                path="what-are-consular-affairs"
                element={<WhatAreConsularAffairs />}
              />
              <Route
                path="what-are-diplomatic-networks"
                element={<WhatAreDiplomaticNetworks />}
              />
              <Route path="etymology-and-history" element={<Etymology />} />
              <Route
                path="1961-and-1963-vienna-conventions"
                element={<ViennaConventions />}
              />
              <Route
                path="consular-jobs-and-internships"
                element={<JobsAndInternships />}
              />
              <Route path="did-you-know" element={<DidYouKnow />} />
              <Route
                path="diplomatic-directory"
                element={<DiplomaticDirectory />}
              />
              <Route
                path="global-consular-forum"
                element={<GlobalConsularForum />}
              />
              <Route path="glossary" element={<Glossary />} />
              <Route path="interesting-links" element={<InterestingLinks />} />
              <Route
                path="international-organizations"
                element={<LawRegulations />}
              />
              <Route
                path="migration-laws-regulations-and-policies"
                element={<Migrations />}
              />
              <Route
                path="passports-visas-and-migration-fraud"
                element={<Passports />}
              />

              {/*The Research Institute tab*/}
              <Route path="about" element={<About />} />
              <Route path="research-fellows" element={<ResearchFellows />} />
              <Route path="contributors" element={<Contributors />} />
              <Route path="correspondents" element={<Correspondents />} />
              <Route path="partners" element={<Partners />} />
              <Route path="notice" element={<Notice />} />
              <Route path="contact" element={<Contact />} />
              <Route
                path="support-consular-research"
                element={<SupportConsularResearch />}
              />
              <Route path="privacy-and-terms" element={<PrivacyAndTerms />} />
              <Route exact path="/" element={<Home />} />

              {/* Route de fallback pour les chemins invalides */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </main>
        <footer>
          <CustomFooter />
        </footer>
      </BrowserRouter>
    </div>
  );
}

export default App;
